import { render, staticRenderFns } from "./UserDataMask.vue?vue&type=template&id=69581387&"
import script from "./UserDataMask.vue?vue&type=script&lang=js&"
export * from "./UserDataMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports